import { SettingScope } from '../services/UserSettingsService';

/**
 * File Upload Limits
 * RestDB.io supports up to 15MB media files
 */
export const FileUpload = {
  /** Maximum file size in bytes (15MB) */
  MAX_SIZE_BYTES: 15 * 1024 * 1024,
  
  /** Maximum file size in MB (for display/error messages) */
  MAX_SIZE_MB: 15,
  
  /** Allowed image MIME types */
  ALLOWED_IMAGE_TYPES: [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/svg+xml'
  ]
};

export const AppSettings = {
  THEME: {
    key: 'theme',
    defaultValue: 'light',
    scope: SettingScope.LOCAL | SettingScope.REMOTE
  },
  SHOW_FORM_BORDER: {
    key: 'app-config', // ConfigManager uses this key and stores an object
    defaultValue: { showFormBorder: true },
    scope: SettingScope.LOCAL
  },
  SIDEBAR_COLLAPSED: {
    key: 'ui.sidebar.collapsed',
    defaultValue: false,
    scope: SettingScope.LOCAL
  },
  NOTIFICATIONS_ENABLED: {
    key: 'ui.notifications.enabled',
    defaultValue: true,
    scope: SettingScope.REMOTE
  },
  DENSITY: {
    key: 'ui.density',
    defaultValue: 'normal',
    scope: SettingScope.REMOTE
  },
  DEFAULT_PAGE_SIZE: {
    key: 'ui.grid.defaultPageSize',
    defaultValue: 25,
    scope: SettingScope.LOCAL
  },
  
  // Search persistence - save last search tree for each entity type
  LAST_CONTACT_SEARCH: {
    key: 'search.contact.lastTree',
    defaultValue: null as string | null,
    scope: SettingScope.LOCAL
  },
  LAST_COMPANY_SEARCH: {
    key: 'search.company.lastTree',
    defaultValue: null as string | null,
    scope: SettingScope.LOCAL
  },
  
  // Contact picker modal - remember last search
  LAST_CONTACT_PICKER_SEARCH: {
    key: 'search.contactPicker.lastTree',
    defaultValue: null as string | null,
    scope: SettingScope.LOCAL
  }
};
